import { render, staticRenderFns } from "./EnvironmentalSection.vue?vue&type=template&id=72dd1865&scoped=true&"
import script from "./EnvironmentalSection.vue?vue&type=script&lang=js&"
export * from "./EnvironmentalSection.vue?vue&type=script&lang=js&"
import style0 from "./EnvironmentalSection.vue?vue&type=style&index=0&id=72dd1865&scoped=true&lang=css&"
import style1 from "./AssessmentModule.css?vue&type=style&index=1&id=72dd1865&scoped=true&lang=css&"
import style2 from "../../sass/components/continue-section.css?vue&type=style&index=2&id=72dd1865&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dd1865",
  null
  
)

export default component.exports